export const peek = (arr) => [arr.length - 1];
export function capitalizeFirstLetter(string = "") {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function sum(prev, next) {
  return prev + next;
}

export function formatDatetimeForUi(dateTimeStr) {
  if (dateTimeStr === "") {  // for invalid date
    return dateTimeStr
  }
  const date = new Date(dateTimeStr + "+00:00");
  return date.toLocaleTimeString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",

  });
}

export function formatTimeForUi(dateTimeStr) {
  const date = new Date(dateTimeStr + "+00:00");
  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTimeRangeForUi(time1, time2) {
  if (time1 === time2) {
    return formatTimeForUi(time1)
  } else {
    return formatTimeForUi(time1) +
      "–" +
      formatTimeForUi(time2)
  }
}

export function formatTimeWindowsForUi(earliestDateTimeStr, latestDateTimeStr) {
  const earliestDateTime = new Date(earliestDateTimeStr + "+00:00");
  const latestDateTime = new Date(latestDateTimeStr + "+00:00");

  let timewindowCollection = [];

  for (var i = 0; i < 12; i++) {
    let lowerDatetime = new Date(
      earliestDateTime.getTime() + i * 1000 * 60 * 60
    );
    let upperDatetime = new Date(
      earliestDateTime.getTime() + (i + 1) * 1000 * 60 * 60
    );

    let timewindowString =
      lowerDatetime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
      }) +
      ":00 - " +
      upperDatetime.toLocaleTimeString("en-GB", {
        hour: "2-digit",
      }) +
      ":00";

    timewindowCollection.push(timewindowString);

    if (upperDatetime.getTime() >= latestDateTime.getTime()) {
      let upperDatetime = new Date(latestDateTime.getTime() + 1000 * 60 * 60);
      let timewindowString =
        latestDateTime.toLocaleTimeString("en-GB", { hour: "2-digit" }) +
        ":00 - " +
        upperDatetime.toLocaleTimeString("en-GB", { hour: "2-digit" }) +
        ":00";
      timewindowCollection.push(timewindowString);
      break;
    }
  }

  return timewindowCollection;
}

export function formatTimeWindowForUi(dateTimeStr) {
  const lowerDatetime = new Date(dateTimeStr + "+00:00");
  const upperDatetime = new Date(lowerDatetime.getTime() + 1000 * 60 * 60);

  let timewindowString =
    lowerDatetime.toLocaleTimeString("en-GB", { hour: "2-digit" }) +
    ":00 - " +
    upperDatetime.toLocaleTimeString("en-GB", { hour: "2-digit" }) +
    ":00";
  return timewindowString;
}

export function lang() {
  return navigator.languages
    ? navigator.languages[0] || navigator.language
    : "en-US";
}

export function dateOnly(date) {
  const dateFormatted = new Intl.DateTimeFormat(lang(), {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
  return `${dateFormatted}`;
}

export function months(format = "long") {
  const formatter = new Intl.DateTimeFormat(lang(), { month: format });
  return new Array(12)
    .fill(0)
    .map((_, i) => formatter.format(new Date(1970, i, 1)));
}
